import { END_RULES_COMBINE, END_RULE_TYPE } from '../constants/endRulesTypes'
import { createLocalId } from './ids'

export const createEmptyEndRule = (overrides = {}) => ({
  id: createLocalId('end_rule'),
  type: END_RULE_TYPE.relativeToVisit,
  offset: { amount: 7, unit: 'days', direction: 'after' },
  count: 12,
  byArm: {},
  ...overrides,
})

export const createEmptyEndRules = (overrides = {}) => ({
  combine: END_RULES_COMBINE.earliestOf,
  rules: [],
  ...overrides,
})
